export enum ListViewQueryParams {
  FilterView = 'view',
  Filters = 'filters',
}
